module.exports = __webpack_public_path__ + "media/images/fallback/figures/search_thumbnail/default_article_image_1-044ad104ac9454a253ec63aa0f734a0e.png";